import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../services/apiService";

const CURRENCY_SELECT_GET_CURRENCIES = "currencySelectField/getCurrencies";

export const getCurrencies = createAsyncThunk(
  CURRENCY_SELECT_GET_CURRENCIES,
  async (payload, { rejectWithValue }) => {
    const { token } = payload;
    const url = `/currencies`;
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await get(url, config);
      return {
        currencies: data.map(({ currency_alpha3_code }) => ({
          value: currency_alpha3_code,
          label: currency_alpha3_code,
        })),
      };
    } catch (error) {
      console.error("Error getting currencies thunk:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

